import { UtilsString } from '@/utils/utils-string';

export default class TokenService {

    private tokenName = 'token';

    public hasToken() {
        return !UtilsString.IsNullOrWhiteSpace(this.getToken());
    }

    public setToken(token: string) {
        window.localStorage.setItem(this.tokenName, token);
    }

    public getToken() {
        return window.localStorage.getItem(this.tokenName);
    }

    public clearToken() {
        window.localStorage.removeItem(this.tokenName);
    }

}

export const ssmTokenService = new TokenService();
